import {inject, Pipe, PipeTransform} from '@angular/core';
import {Matchmode} from '../model/events/Matchmode';
import {ViewHelper} from '../modules/shared/helper/view-helper';
import {TranslateService} from '@ngx-translate/core';

@Pipe({standalone: true, name: 'setlegmodePipe'})
export class SetlegmodePipe implements PipeTransform
{
  private translate = inject(TranslateService);
  transform(matchmode: Matchmode, setsLegs: string, short: boolean): string
  {
    const isMobile = ViewHelper.isMobile();
    if (setsLegs === 'sets')
    {
      return this.getStringSets(matchmode, true, short, isMobile);
    }
    else if (setsLegs === 'legs')
    {
      return this.getStringLegs(matchmode, short, isMobile);
    }
    else
    {
      let str: string;
      const setsStr = this.getStringSets(matchmode, false, short, isMobile);
      const legsStr = this.getStringLegs(matchmode, short, isMobile);
      if (setsStr && setsStr.length > 0)
      {
        str = setsStr + '/' + legsStr;
      }
      else
      {
        str = legsStr;
      }

      if (setsLegs === 'total' && matchmode.matchmodePoints)
      {
        str += ', ' + matchmode.matchmodePoints;
      }

      return str;
    }
  }

  private getStringSets(matchmode: Matchmode, moreThanOne: boolean, short: boolean, isMobile: boolean): string
  {
    if (matchmode.setsTotal && matchmode.setsTotal > 1)
      return matchmode.setsTotal + (short ? '' : ' ' + this.translate.instant('SETS'));
    else if (matchmode.setsBestOf && matchmode.setsBestOf > 1)
      return this.getBestOfText(isMobile) + matchmode.setsBestOf + (short ? '' : ' ' + this.translate.instant('SETS'));
    if (moreThanOne)
      return '-';
    return '';
  }
  private getStringLegs(matchmode: Matchmode, short: boolean, isMobile: boolean): string
  {
    if (matchmode.legsTotal && matchmode.legsTotal > 1)
      return matchmode.legsTotal + (short ? '' : ' ' + this.translate.instant('LEGS'));
    else if (matchmode.legsBestOf && matchmode.legsBestOf > 1)
      return this.getBestOfText(isMobile) + matchmode.legsBestOf + (short ? '' : ' ' + this.translate.instant('LEGS'));
    else if (matchmode.legsBestOf && matchmode.legsBestOf === 1)
      return '1 Leg';
    return '-';
  }

  private getBestOfText(isMobile: boolean): string
  {
    return (isMobile ? this.translate.instant( 'BEST_OF_SHORT') : this.translate.instant( 'BEST_OF')) + ' ';
  }
}
